import { LegalClientSourcesOfIncomeEntity } from 'api/types/entity';
import { FileUpload } from 'hooks/useFilesUpload';
import { TFunc } from 'libs/i18n';

import { SourcesOfIncomeFormType } from '../../forms/sourcesOfIncomeForm';

export const getInitialData = (
  sourcesOfIncome: LegalClientSourcesOfIncomeEntity | undefined,
  t: TFunc
) => {
  const values: SourcesOfIncomeFormType | undefined = sourcesOfIncome
    ? {
        ...sourcesOfIncome,
        incomeSources: sourcesOfIncome.incomeSources?.map((v) => ({
          value: v,
          label: t(
            `onboarding.legalClientSourcesOfIncome.incomeSources.types.${v}`
          ),
        })),
        financialSources: sourcesOfIncome.financialSources?.map((v) => ({
          value: v,
          label: t(
            `onboarding.legalClientSourcesOfIncome.financialSources.types.${v}`
          ),
        })),

        fileIds: sourcesOfIncome.files.map((v) => v.id),
      }
    : undefined;

  const files: FileUpload[] | undefined = sourcesOfIncome?.files.map(
    (v) =>
      new FileUpload({ name: v.name, size: v.size }, undefined, false, v.id)
  );
  return { values, files };
};
